/* eslint-disable no-mixed-operators */
/* eslint-disable max-classes-per-file */
/* eslint-disable import/no-mutable-exports */
/* eslint-disable prefer-const */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-unused-vars */
import React, {
  useState, useRef, useEffect, useLayoutEffect, useMemo,
} from 'react';
import ActionButton from 'components/Common/ActionButton';
import SideBar from 'components/pages/Marketing/Assets/SideBar';
import LoginNavButtons from 'components/pages/Marketing/Assets/LoginNavButtons';
import Container from 'components/pages/Marketing/Assets/Container';
import { useHistory } from 'react-router-dom';
import StrictContainer from 'components/pages/Marketing/Assets/StrictContainer';
import classNames from 'classnames';
import {
  chart,
  crowd,
} from 'assets/exports/imageExport';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import faker from 'faker';
import Styles from './index.module.css';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

class Calculations {
  constructor(props) {
    this.investment = props?.investment ?? 0;
    this.clientPrice = props?.clientPrice ?? 0;
    this.brand = props?.brand ?? '';
  }

  clone() {
    const c = new Calculations();
    c.investment = this.investment;
    c.clientPrice = this.clientPrice;
    c.brand = this.brand;
    return c;
  }
}

class Data {
  constructor(props) {
    this.labels = props?.labels ?? [];
    this.datasetDataLow = props?.datasetDataLow ?? 0;
    this.datasetDataHigh = props?.datasetDataHigh ?? 0;
    this.datasets = [
      {
        label: '低標',
        data: this.datasetDataLow,
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
      {
        label: '高標',
        data: this.datasetDataHigh,
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ];
  }

  clone() {
    const c = new Data();
    c.labels = this.labels;
    c.datasetData = this.datasetData;
    c.datasets = this.datasets;
    return c;
  }
}

function MarketingCalculator() {
  // STATIC STATE
  const labels = [...Array(12).keys()].map((i) => i + 1);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: '預估達成業績',
      },
    },
  };

  const levers = {
    Traffic: '增加流量',
    Performance: '業績飆漲',
  };

  const tabs = {
    NewBrand: '新品牌',
    OldBrand: '成熟品牌',
  };

  const stepNames = {
    Calculator: 'Calculator',
    Performance: 'Performance',
  };

  const trafficData = {
    [tabs.OldBrand]: {
      low: [0.6, 0.8, 1.1, 1.3, 1.5, 1.7, 2.0, 2.2, 2.4, 2.6, 2.9, 3.6],
      high: [1.2, 1.6, 1.9, 2.3, 2.7, 3.0, 3.4, 3.7, 4.1, 4.5, 4.8, 6.0],
    },
    [tabs.NewBrand]: {
      low: [0.2, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.1, 1.2, 1.3, 1.4, 1.8],
      high: [0.6, 0.8, 1.1, 1.3, 1.5, 1.7, 2.0, 2.2, 2.4, 2.6, 2.9, 3.6],
    },
    cpc: 10,
  };

  const performanceData = {
    [tabs.OldBrand]: {
      low: [0.6, 0.8, 1.1, 1.3, 1.5, 1.7, 2.0, 2.2, 2.4, 2.6, 2.9, 3.6],
      high: [1.0, 1.6, 1.9, 2.3, 2.7, 3.0, 3.4, 3.7, 4.1, 4.5, 4.8, 6.0],
    },
    [tabs.NewBrand]: {
      low: [0.2, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.1, 1.2, 1.3, 1.4, 1.8],
      high: [0.6, 0.8, 1.1, 1.3, 1.5, 1.7, 2.0, 2.2, 2.4, 2.6, 2.9, 3.6],
    },
    cpc: 10,
  };

  // DYNAMIC STATE
  const [activeLever, setActiveLever] = useState(null);
  const [activeTab, setActiveTab] = useState(tabs.NewBrand);
  const [formIsActive, setFormIsActive] = useState(false);
  const [activeStep, setActiveStep] = useState();
  const [calculations, setCalculations] = useState(new Calculations());
  const [chartData, setChartData] = useState(new Data());
  const [performanceDataSum, setPerformanceDataSum] = useState({});
  const [trafficDataSum, setTrafficDataSum] = useState({});

  // FUNCTIONS
  const numberInputValidation = (e, field) => {
    const newCalculations = calculations.clone();
    newCalculations[field] = e.target.value.replace(/[^\d]+/g, '');
    setCalculations(newCalculations);
  };

  const calculateTraffic = () => {
    const { investment, clientPrice } = calculations;
    const statistic = {
      low: [],
      high: [],
    };

    const sum = {
      low: 0,
      high: 0,
    };

    [...(Object.keys(trafficData[activeTab]))].forEach((key) => {
      trafficData[activeTab][key].forEach((digit) => statistic[key].push((investment * clientPrice * digit) / 1000));
    });

    [...(Object.keys(statistic))].forEach((key) => {
      sum[key] = statistic[key].reduce((accumulator, item) => accumulator + item, 0);
    });

    const newData = new Data({ datasetDataLow: statistic.low, datasetDataHigh: statistic.high, labels });
    setChartData(newData);
    setTrafficDataSum(sum);
  };

  const calculatePerformance = () => {
    const { investment, clientPrice } = calculations;
    const statistic = {
      low: [],
      high: [],
    };

    [...(Object.keys(performanceData[activeTab]))].forEach((key) => {
      performanceData[activeTab][key].forEach((digit) => statistic[key].push(investment / (investment * 1000 / clientPrice / digit)));
    });

    const newData = new Data({ datasetDataLow: statistic.low, datasetDataHigh: statistic.high, labels });
    setChartData(newData);
  };

  const calculatePerformanceInvestment = () => {
    const { investment, clientPrice } = calculations;

    const statistic = {
      low: [],
      high: [],
    };

    const sum = {
      low: 0,
      high: 0,
    };

    [...(Object.keys(trafficData[activeTab]))].forEach((key) => {
      trafficData[activeTab][key].forEach((digit) => statistic[key].push(1000 * investment / clientPrice / digit));
    });

    [...(Object.keys(statistic))].forEach((key) => {
      sum[key] = statistic[key].reduce((accumulator, item) => accumulator + item, 0);
    });

    setPerformanceDataSum(sum);
  };

  const calculationHandler = () => {
    switch (activeLever) {
      case levers.Traffic:
        calculateTraffic();
        break;
      case levers.Performance:
        calculatePerformance();
        calculatePerformanceInvestment();
        break;
      default:
        alert('無知步驟');
    }
  };

  const numberFormat = (value) => (+value).toLocaleString();

  const calculatePerformanceAvg = (value) => numberFormat(Math.round(value / labels.length));

  return (
    <>
      <Container>
        <StrictContainer>
          <SideBar />
          <LoginNavButtons />
        </StrictContainer>
        <StrictContainer>
          <div className={Styles.calculator}>
            <h1 className={Styles.calculatorTitle}>報酬試算<br /><span>讓廣告實現您的夢想</span></h1>
            <div className={Styles.calculatorLevers_wrapped}>
              <h3 className={Styles.calculatorLeversTitle}>夢想目標</h3>
              <div className={classNames(
                Styles.calculatorLevers,
                { [Styles.calculatorLevers_inactive]: activeStep === stepNames.Performance },
              )}
              >
                {Object.keys(levers).map((name) => (
                  <div
                    key={name}
                    className={classNames(
                      Styles.calculatorLever,
                      {
                        [Styles.calculatorLever_clicked]: activeLever,
                        [Styles.calculatorLever_active]: activeLever === levers[name],
                        [Styles.calculatorLever_inactive]: activeStep === stepNames.Performance,
                      },
                    )}
                    onClick={() => {
                      setActiveLever(levers[name]);
                      setFormIsActive(true);
                      !activeStep && setActiveStep(stepNames.Calculator);
                    }}
                  >
                    <span className={Styles.calculatorLeverTitle}>{levers[name]}</span>
                    <div className={Styles.calculatorLeverImg_wrapped}>
                      <img src={levers[name] === levers.Traffic ? crowd : chart} alt="" className={Styles.calculatorLeverImg} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className={classNames(
              Styles.calculatorForm,
              { [Styles.calculatorForm_active]: formIsActive && activeStep === stepNames.Calculator },
            )}
            >
              <div className={Styles.calculatorField_wrapped}>
                <h3 className={Styles.calculatorFieldTitle}>每月投資金額</h3>
                <div className={Styles.calculatorFieldContainer}>
                  <input
                    onChange={(e) => numberInputValidation(e, 'investment')}
                    value={numberFormat(calculations.investment)}
                    type="text"
                    className={Styles.calculatorField}
                  />
                  <span className={Styles.calculatorFieldLabel}>元/月</span>
                </div>
              </div>
              <div className={Styles.calculatorField_wrapped}>
                <h3 className={Styles.calculatorFieldTitle}>均客單價</h3>
                <div className={Styles.calculatorFieldContainer}>
                  <input
                    onChange={(e) => numberInputValidation(e, 'clientPrice')}
                    value={numberFormat(calculations.clientPrice)}
                    type="text"
                    className={Styles.calculatorField}
                  />
                  <span className={Styles.calculatorFieldLabel}>元</span>
                </div>
              </div>
              <div className={Styles.calculatorField_wrapped} style={{ marginRight: 'auto' }}>
                <h3 className={Styles.calculatorFieldTitle}>均客單價</h3>
                <div className={Styles.calculatorFieldRadios}>
                  {Object.keys(tabs).map((name) => (
                    <div
                      key={name}
                      className={classNames(Styles.calculatorFieldRadio, {
                        [Styles.calculatorFieldRadio_active]: tabs[name] === activeTab,
                      })}
                      onClick={() => setActiveTab(tabs[name])}
                    >{tabs[name]}
                    </div>
                  ))}
                </div>
              </div>
              <ActionButton
                onClick={() => {
                  calculationHandler();
                  setActiveStep(stepNames.Performance);
                }}
                className={Styles.calculatorConfrim}
              >查看夢想計畫 »
              </ActionButton>
            </div>
            <div className={classNames(
              Styles.calculatorResult,
              { [Styles.calculatorResult_active]: activeStep === stepNames.Performance },
            )}
            >
              <div className={Styles.calculatorResultBoard}>
                <div className={Styles.calculatorResultFields}>
                  <p className={Styles.calculatorResultTitle}>廣告業績目標: <span className={Styles.calculatorResultText}>{numberFormat(calculations.investment)}$</span></p>
                  <p className={Styles.calculatorResultTitle}>均客單價: <span className={Styles.calculatorResultText}>{numberFormat(calculations.clientPrice)}$</span></p>
                  <p className={Styles.calculatorResultTitle}>品牌知名度: <span className={Styles.calculatorResultText}>{activeTab}</span></p>
                </div>
              </div>
              <Line options={options} data={chartData} />
              <p className={Styles.calculatorResultChartSubtitle}>成效為預估，非保證成效</p>
              {activeLever === levers.Performance && (
              <div className={Styles.calculatorResultResume}>
                <h3 className={Styles.calculatorResultResumeTitle}>每月投資金額:</h3>
                <span className={Styles.calculatorResultResumeText}>{`$${calculatePerformanceAvg(performanceDataSum?.high)} ~ $${calculatePerformanceAvg(performanceDataSum?.low)}`}</span>
              </div>
              )}
              {activeLever === levers.Traffic && (
              <div className={Styles.calculatorResultResume}>
                <h3 className={Styles.calculatorResultResumeTitle}>預估達成業績:</h3>
                <span className={Styles.calculatorResultResumeText}>{`$${numberFormat(Math.round(trafficDataSum?.low))} ~ $${numberFormat(Math.round(trafficDataSum?.high))}`}</span>
              </div>
              )}
              <div className={Styles.calculatorResultActions}>
                <ActionButton onClick={() => setActiveStep(stepNames.Calculator)}>« 重新計算</ActionButton>
                <ActionButton>開始投資 »</ActionButton>
              </div>
            </div>
          </div>
        </StrictContainer>
      </Container>
    </>
  );
}

export default MarketingCalculator;
